import React from 'react';
import { X } from 'lucide-react';

const TEMPLATES = [
  { key: 'centered_discount', name: 'Centrado con descuento', color: '#6366f1', desc: 'Modal centrado con imagen, código de descuento y formulario.' },
  { key: 'sidebar_newsletter', name: 'Barra lateral', color: '#111827', desc: 'Panel discreto en la esquina inferior, ideal para newsletter.' },
  { key: 'exit_intent', name: 'Salida (exit-intent)', color: '#ef4444', desc: 'Aparece cuando el visitante va a abandonar la página.' },
];

export const TemplatePickerModal = ({ onClose, onSelect }) => {
  return (
    <div
      data-testid="popup-template-picker-modal"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-gray-900 border border-gray-700 rounded-2xl p-6 w-full max-w-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-5">
          <div>
            <h3 className="text-white font-semibold text-lg">Elige una plantilla</h3>
            <p className="text-gray-500 text-xs mt-1">Podrás personalizar todo el contenido después.</p>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white" data-testid="template-picker-close-btn">
            <X size={18} />
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {TEMPLATES.map(t => (
            <button
              key={t.key}
              onClick={() => onSelect(t.key)}
              data-testid={`template-option-${t.key}`}
              className="text-left bg-gray-800/60 border border-gray-700 rounded-xl p-4 hover:border-indigo-500 transition-colors group"
            >
              <div
                className="w-full h-20 rounded-lg mb-3 flex items-center justify-center"
                style={{ background: t.color }}
              >
                <div className="w-10 h-2 rounded-full bg-white/70" />
              </div>
              <p className="text-white text-sm font-medium mb-1 group-hover:text-indigo-400">{t.name}</p>
              <p className="text-gray-500 text-xs leading-snug">{t.desc}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
